var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 36,
    viewBox: "0 0 84 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2451 0.752686L0 34.8735H28.0001L33.2451 26.9988V0.752686Z",
    fill: "var(--base-warning, #00CEB3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M83.9473 0L56.6614 0L50.2256 8.88685V35.2266L83.9473 0Z",
    fill: "var(--base-warning, #00CEB3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreicon);
export default __webpack_public_path__ + "static/media/storeicon.5671a0be9c578aca0e3a7b1e65bf6c4f.svg";
export { ForwardRef as ReactComponent };